export default __webpack_public_path__ + "static/SRF 3350ACS50 - Product Specifications & Technical Data-d9f0039444d51fda93326ef167a9e827.pdf";